import { OpenDcCampaignType } from "shared-utils/enums/opendc";
import { EXPORT_FORMAT, PLATFORM } from "shared-utils/enums/exports";
import { DISTRIBUTION_CHANNEL } from "shared-utils/enums/client";

export const DistributionChannelLabel = {
    [DISTRIBUTION_CHANNEL.WPP_MEDIA]: "WPP Media",
    [DISTRIBUTION_CHANNEL.CONNECT]: "Connect",
    [DISTRIBUTION_CHANNEL.NONE]: "None"
} as const;

export const PlatformLabel = {
    [PLATFORM.DOUBLECLICK]: "Google",
    [PLATFORM.DOUBLECLICK_SV]: "Google Studio Dynamic",
    [PLATFORM.FLASHTALKING]: "Flashtalking",
    [EXPORT_FORMAT.FLASHTALKING_EXCEL]: "Flashtalking Excel",
    [EXPORT_FORMAT.FLASHTALKING_ASSETS]: "Flashtalking Assets",
    [PLATFORM.FACEBOOK]: "Meta Ads Manager",
    [PLATFORM.OPENDC]: "CO",
    [PLATFORM.CREATIVEX]: "CreativeX",
    [PLATFORM.GENERIC]: "Generic",
    [PLATFORM.GENERIC_LITE]: "Generic Lite"
} as const;

export const OpenDcCampaignTypeLabel = {
    [OpenDcCampaignType.display]: "Display",
    [OpenDcCampaignType.video]: "Video",
    [OpenDcCampaignType.socialVideo]: "Social Video",
    [OpenDcCampaignType.socialStatic]: "Social Static",
    [OpenDcCampaignType.tiktokVideo]: "TikTok Video",
    [OpenDcCampaignType.tiktokStatic]: "TikTok Image"
} as const;

export const CreativeXCampaignType = {
    Brand: "BRAND",
    Creator: "CREATOR"
} as const;

export const CreativeXAssetType = {
    Image: "IMAGE",
    Video: "VIDEO"
} as const;
